import { render, staticRenderFns } from "./SystemSetup.vue?vue&type=template&id=a8b3004c&"
import script from "./SystemSetup.vue?vue&type=script&lang=js&"
export * from "./SystemSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports